module.exports = __webpack_public_path__ + "img/AP.3a043f5c.png";